const DEFAULT_STEP = 0.1;
const CHARACTER_LENGTH = 11;
const html = require("choo/html");

let _shiftDown = false;
let _installed = false;
function _ensureShiftTracker() {
  if (_installed) return;
  _installed = true;
  const onDown = (e) => {
    if (e.key === "Shift") _shiftDown = true;
  };
  const onUp = (e) => {
    if (e.key === "Shift") _shiftDown = false;
  };
  const onBlur = () => {
    _shiftDown = false;
  };
  window.addEventListener("keydown", onDown, true);
  window.addEventListener("keyup", onUp, true);
  window.addEventListener("blur", onBlur, true);
  document.addEventListener(
    "visibilitychange",
    () => {
      if (document.hidden) _shiftDown = false;
    },
    true
  );
}
function isShiftDown() {
  _ensureShiftTracker();
  return _shiftDown;
}

// ---- helpers ----
function map(n, start1, stop1, start2, stop2) {
  return ((n - start1) * (stop2 - start2)) / (stop1 - start1) + start2;
}
function clamp(v, lo, hi) {
  return Math.min(hi, Math.max(lo, v));
}
function decimalsFromStep(s) {
  const str = String(s);
  if (str.includes("e") || str.includes("E")) {
    const num = Number(s);
    let d = 0;
    while (d < 10 && Math.round(num * 10 ** d) / 10 ** d !== num) d++;
    return d;
  }
  const i = str.indexOf(".");
  return i === -1 ? 0 : str.length - i - 1;
}
function snapToGrid(value, step, min, max) {
  if (!Number.isFinite(value) || !Number.isFinite(step) || step === 0) {
    return clamp(min, min, max);
  }
  const k = Math.round((value - min) / step);
  const raw = min + k * step; // ← put min back
  const dec = decimalsFromStep(step);
  let fixed = Number(raw.toFixed(dec));
  if (Object.is(fixed, -0)) fixed = 0; // avoid -0
  return clamp(fixed, min, max);
}

module.exports = function InputSlider(args) {
  let {
    label,
    value = 0,
    min = 0,
    max = 100,
    step = DEFAULT_STEP,
    shiftStep = null, // big step while holding Shift; defaults to step*10
    disabled = false,
    selected = false,
    onInput = () => false,
    onChange = () => false,
    tooltip = null,
    id = null,
  } = args;
  min = Number(min);
  max = Number(max);
   value = Number(value);
   step = Number(step);
   if (shiftStep != null) shiftStep = Number(shiftStep);
  const bigStep = shiftStep == null ? step * 5 : shiftStep;
  const w = map(value, min, max, 0, 100);
  const displayDecimals = decimalsFromStep(step);
  const roundedValue = Number(value).toFixed(displayDecimals);
  const textFieldWidth = String(roundedValue).length * CHARACTER_LENGTH;

  const applySnap = (e) => {
    const raw = parseFloat(e.target.value);
    const chosenStep = isShiftDown() ? bigStep : step;
    const snapped = snapToGrid(raw, chosenStep, min, max);
    if (!Number.isNaN(snapped)) e.target.value = String(snapped);
  };

  const handleInput = (e) => {
    applySnap(e);
    onInput(e);
  };
  const handleChange = (e) => {
    applySnap(e);
    onChange(e);
  };

  const disabledClass = disabled ? "disabled" : "";
  const selectedClass = selected ? "selected" : "";

  return html`
    <div
      class="input input-slider ${disabledClass}"
      id=${id == null ? null : id}
    >
      ${tooltip}
      <label>${label}</label>
      <div class="input-area ${selectedClass}">
        <div class="foreground" style="width: ${w}%"></div>

        <input
          type="range"
          min=${min}
          max=${max}
          step="any"
          value=${value}
          oninput=${handleInput}
          onchange=${handleChange}
          onmouseup=${(e) => e.target.blur()}
        />

        <input
          type="number"
          class="value"
          min=${min}
          max=${max}
          style="width:${textFieldWidth}rem;"
          value="${roundedValue}"
          oninput=${handleInput}
          onchange=${handleChange}
        />
      </div>
    </div>
  `;
};
